<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>

    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name">
          <span class="leftLine"></span><span style="color: #2ac1ff">求助</span>
        </div>
        <div class="closeBtn" @click="close"></div>
      </div>
    </div>
    <div class="middleOutLine" id="msgContent">
      <el-form :model="alarmInfo" :rules="rules" ref="ruleForm">
        <div class="messageRow notisfy">
          <div class="circleType">求助</div>
          <div
            class="margin_0_10"
            :class="{
              redLevel: alarmInfo.AlerteLevel === 10,
              orangeLevel: alarmInfo.AlerteLevel === 7,
              yellowLevel: alarmInfo.AlerteLevel === 5,
              blueLevel: alarmInfo.AlerteLevel === 3,
            }"
          >
            求助
          </div>
          <div class="margin_left">
            {{ getProcessStatusName(alarmInfo.ProcessStatus) }}
          </div>
        </div>
        <div class="notisfy">
          <span style="margin-right: 20px"
            >时间：{{ formatDate(alarmInfo.BeginDate) }} </span
          >来源：{{ alarmInfo.SourceDesc }}
        </div>
        <div class="notisfy" v-if="alarmInfo.ProcessStatus != '0'">
          <span style="margin-right: 20px"
            >受理方式：{{ getWay(alarmInfo.ProcessWay) }} </span
          >受理时间：{{ formatDate(alarmInfo.AcceptDate) }}
        </div>
        <div class="notisfy" v-if="alarmInfo.ProcessStatus != '0'">
          <span style="margin-right: 20px"
            >事件类型：{{ alarmInfo.EventType }}
          </span>
        </div>
        <div class="notisfy">详情</div>
        <div class="notisfy">
          <span style="margin-right: 20px">姓名：{{ alarmInfo.Contact }} </span
          >电话：{{ alarmInfo.Phone }}
        </div>
        <div class="notisfy">描述</div>
        <div class="notisfy" style="margin-left: 7%">
          {{ alarmInfo.Content }}
        </div>

        <div class="mapBox">
          <!--  ref="map-mapview" -->
          <div class="covermap">
            <div
              class="map"
              id="allmapIndex"
              style="width: 100%; height: 100%; z-index: 2 !important"
            ></div>
          </div>

          <div class="coverbg"></div>
        </div>
        <el-form-item
          label="初判事件类型"
          prop="EventType"
          v-if="isShowFooter && alarmInfo.ProcessStatus == 0"
        >
          <el-radio-group v-model="alarmInfo.EventType">
            <el-radio label="伤员求助"></el-radio>
            <el-radio label="暴雨求助"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="确认事件类型"
          prop="EventType"
          v-if="isShowRemark && alarmInfo.ProcessStatus == 1"
        >
          <el-radio-group
            v-model="alarmInfo.EventType"
            :disabled="alarmInfo.ProcessStatus == 2"
          >
            <el-radio label="伤员求助"></el-radio>
            <el-radio label="暴雨求助"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="结案说明"
          prop="ProcessConclusion"
          v-if="isShowRemark"
        >
          <el-input
            type="textarea"
            v-model="alarmInfo.ProcessConclusion"
            :disabled="alarmInfo.ProcessStatus == 2"
          ></el-input>
        </el-form-item>
        <el-form-item class="right" v-if="isShowSubmit">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="msgfooter">
      <el-form :model="alarmInfo" :rules="rules">
        <!-- <div class="notisfy">结案说明</div> -->
        <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
          v-if="isShowWayBtn"
        >
          <el-button
            @click="handleAccept()"
            style="margin-left: 15px"
            v-if="alarmInfo.ProcessStatus == 0"
            >受理</el-button
          >
          <el-button
            @click="handleRefuse()"
            style="margin-left: 15px"
            v-if="alarmInfo.ProcessStatus == 0"
            >不予受理（虚报）</el-button
          >
          <el-button
            @click="handleFinish()"
            v-if="alarmInfo.ProcessStatus === 1"
            >结案</el-button
          >
          <el-button
            @click="handleTask()"
            style="margin-left: 15px"
            v-if="alarmInfo.ProcessStatus == 0"
            >发任务</el-button
          >
          <el-button
            @click="handleEmergency()"
            style="margin-left: 15px"
            v-if="alarmInfo.ProcessStatus == 0"
            >转应急</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import { mapGetters, mapState, mapActions } from "vuex";
import {
  handleMsg,
  getMsgInfo,
  saveMsg,
} from "../../../../../../request/msgApi";

export default {
  data() {
    return {
      ruleForm: {
        content: "",
      },
      rules: {
        EventType: [
          { required: true, message: "请选择事件类型", trigger: "change" },
        ],
        ProcessConclusion: [
          { required: true, message: "请填写结案说明", trigger: "change" },
        ],
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      fileList2: [],
      dialogVisible2: false,
      dialogImageUrl2: "",
      delFileList: [],
      center: [],
      center2: [],
      isHavePosition: false,
      mapInstance: "",
      currentValue: "",
      preValue: "",
      resultData: {},

      levelName: "",
      msgTypeName: "",
      alarmInfo: {},
      AlerteLevelArr: [],
      AlertTypeArr: [],
      isShowRemark: false,
      isShowFooter: false,
      isShowWayBtn: false,
      isShowSubmit: false,
    };
  },
  filters: {
    getlevelName(val) {
      if (val == "warning_level_1") {
        return "一级";
      } else if (val == "warning_level_2") {
        return "二级";
      } else if (val == "warning_level_3") {
        return "三级";
      }
    },
  },
  props: {
    msgId: {
      type: String,
      default: "",
    },
    isShowMsgDetail: {
      type: Boolean,
      default: false,
    },
    alarmId: {
      type: String,
      default: "",
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  created: function () {
    // if (this.isShowMsgDetail && this.msgId) {
    //   this.getDetails();
    // }
    this.alarmLevel();
    this.getAlarmType();
    if (this.isShowMsgDetail && this.alarmId) {
      this.getAlertInfo();
    }
  },
  mounted: function () {},
  methods: {
    ...mapActions(["submitMsgTask"]),
    getAlertInfo() {
      const that = this;
      let searchInfo = {
        Id: this.alarmId,
      };
      that.center = [];
      new MyApis.AlarmApi()
        .GetItemById(searchInfo)
        .then((r) => {
          r = r.data.Data;
          that.alarmInfo = r;
          if (that.alarmInfo.AlertType === "0") {
            that.deviceInfo = JSON.parse(that.alarmInfo.Content);
            that.alarmInfo.Content = "SOS报警——" + that.deviceInfo.DeviceName;
            that.alarmInfo.SourceDesc = "报警柱";
            if (
              that.deviceInfo.Longitude &&
              (that.deviceInfo.Latitude || that.deviceInfo.Laitude) &&
              that.deviceInfo.Longitude != "0" &&
              (that.deviceInfo.Latitude != "0" ||
                that.deviceInfo.Laitude != "0")
            ) {
              that.center.push(that.deviceInfo.Longitude);
              that.center.push(
                that.deviceInfo.Latitude || that.deviceInfo.Laitude
              );
              that.isHavePosition = true;
            } else {
              that.isHavePosition = false;
            }
          } else {
            if (
              that.alarmInfo.Longitude &&
              (that.alarmInfo.Latitude || that.alarmInfo.Laitude) &&
              that.alarmInfo.Longitude != "0" &&
              (that.alarmInfo.Latitude != "0" || that.alarmInfo.Laitude != "0")
            ) {
              that.center.push(that.alarmInfo.Longitude);
              that.center.push(
                that.alarmInfo.Latitude || that.alarmInfo.Laitude
              );
              that.isHavePosition = true;
            } else {
              that.isHavePosition = false;
            }
          }
          if (that.alarmInfo.ProcessStatus !== 0) {
            this.isShowFooter = true;
          } else {
            this.isShowFooter = false;
          }
          if (that.alarmInfo.ProcessStatus == 2) {
            this.isShowRemark = true;
          } else {
            this.isShowRemark = false;
          }
          if (that.alarmInfo.ProcessStatus !== 2) {
            that.isShowWayBtn = true;
          } else {
            that.isShowWayBtn = false;
          }
          this.alarmInfo.ProcessWay = this.alarmInfo.ProcessWay + "";
          this.onDrawMap();
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getProcessStatusName(value) {
      let result = "";
      if (value === 0) {
        result = "待处理";
      } else if (value === 1) {
        result = "待结案";
      } else {
        result = "已完结";
      }
      return result;
    },
    getWay(value) {
      let result = "";
      if (value == "1") {
        result = "转为应急事件";
      } else if (value == "4") {
        result = "受理";
      } else {
        result = "不予受理（虚报）";
      }
      return result;
    },
    getLevel: function (value) {
      let result = "";
      let AlerteLevelArr = this.AlerteLevelArr;
      AlerteLevelArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then((d) => {
          this.AlerteLevelArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then((d) => {
          this.AlertTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    handleTask() {
      this.submitMsgTask(true);
      this.$emit("handleTask", this.resultData);
    },
    handleEmergency() {
      this.$confirm("确认转为应急事件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let path = `/plugin/Emergency/UI/NewEvent?AlarmId=${this.alarmInfo.Id}`;
        this.$router.push(path);
      });
    },
    //受理
    handleAccept() {
      this.isShowFooter = true;
      this.isShowSubmit = true;
      this.alarmInfo.ProcessWay = "4";
      var div = document.getElementById("msgContent");
      setTimeout(() => {
        div.scrollTop = div.scrollHeight;
      }, 100);
    },
    //不予受理
    handleRefuse() {
      this.isShowFooter = true;
      this.isShowSubmit = true;
      this.alarmInfo.ProcessWay = "5";

      var div = document.getElementById("msgContent");
      setTimeout(() => {
        div.scrollTop = div.scrollHeight;
      }, 100);
    },
    //结案
    handleFinish() {
      this.isShowFooter = true;
      this.isShowRemark = true;
      this.isShowSubmit = true;
      var div = document.getElementById("msgContent");
      setTimeout(() => {
        div.scrollTop = div.scrollHeight;
      }, 100);
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },

    //提交
    submit() {
      let status = this.alarmInfo.ProcessStatus;
      if (status == "0" || status == "") {
        //0是待处理 1是待结案
        if (this.alarmInfo.ProcessWay == "1") {
          this.alarmInfo.FinishDate = this.time(new Date());
          this.alarmInfo.AcceptDate = this.time(new Date());
          this.alarmInfo.ProcessConclusion = "已转为应急事件";
          this.alarmInfo.ProcessStatus = "2";
        } else {
          this.alarmInfo.AcceptDate = this.time(new Date());
          this.alarmInfo.ProcessStatus = "1";
        }
      } else if (status == "1") {
        this.alarmInfo.FinishDate = this.time(new Date());
        this.alarmInfo.ProcessStatus = "2";
      }
      if (!this.alarmInfo.EventType) {
        return this.$message.error("请选择初判事件类型！");
      }
      new MyApis.AlarmApi()
        .UpdateItem(this.alarmInfo)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "处理成功！" : "处理失败！",
          });
          if (status == "1") {
            this.logInfo.ActionName = "求助结案";
            this.logInfo.LogMessage = "求助结案成功";
            this.logInfo.PageName = "待结案求助详情";
            this.close();
          } else {
            this.logInfo.ActionName = "求助处理";
            this.logInfo.LogMessage = "求助处理成功";
            this.logInfo.PageName = "待处理求助详情";
            //this.getAlertInfo();
            this.close();
          }
          this.logInfo.ModuleName = "紧急求助";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateMsgStatus(msg) {
      saveMsg(msg).then((res) => {});
    },
    close() {
      this.$emit("closeMsgHelpDetail", false);
    },

    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },

    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmapIndex");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 12);
      var opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
      map.addControl(new BMap.NavigationControl(opts));
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    },
    time(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 110px;
  z-index: 99999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 0.8);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 999999;
    }
  }
  .middleOutLine {
    height: 40.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .coverbg {
    // width: 525px;
    width: 100%;
    height: 274px;
    background: url("../../../../../../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 12000;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    // background-size:cover;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10;
  }
  .redLevel {
    color: red;
  }
  .yellowLevel {
    color: yellow;
  }
  .blueLevel {
    color: blue;
  }
  .orangeLevel {
    color: orange;
  }
  .circleType {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background: #29bfff;
  }
  .messageRow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .margin_0_10 {
    margin: 0 10px;
  }
  .margin_left {
    margin-left: 10rem;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .msgfooter {
    height: 55px;
    width: 100%;
    padding: 10px 20px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
    position: relative;
    z-index: 20;
    // text-align: right;
  }

  .footerHeight1 {
    height: 20rem;
    // overflow: auto;
  }
  .footerHeight {
    height: 25rem;
    overflow: auto;
  }
  .footerHeight2 {
    height: 13rem;
  }
}
</style>
